export function formatPrice(price: number, showDecimalPlaces = true): string {
  return Intl.NumberFormat("pl-PL", {
    ...(showDecimalPlaces && { minimumFractionDigits: 2 }),
  }).format(price);
}
